module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      component: true, disabled: _vm.loading
    }
  }, [(_vm.isNew) ? _c('h1', [_vm._v("Skapa lösenord")]) : _c('h1', [_vm._v("Återställ lösenord")]), _vm._v(" "), (!_vm.loggedIn) ? _c('div', [_c('p', [_vm._v("Ange ett nytt, säkert lösenord nedan (minst 6 tecken långt)")]), _vm._v(" "), _c('Loading', {
    attrs: {
      "show": _vm.loading
    }
  }), _vm._v(" "), _c('div', [_c('label', [_vm._v("Nytt lösenord")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.new_password),
      expression: "user.new_password"
    }],
    attrs: {
      "placeholder": "Nytt lösenord",
      "type": "password"
    },
    domProps: {
      "value": (_vm.user.new_password)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.save()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "new_password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "center wide"
  }, [(_vm.errorMessage) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e(), _vm._v(" "), (_vm.successMessage) ? _c('p', {
    staticClass: "success-message"
  }, [_vm._v(_vm._s(_vm.successMessage))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "center wide"
  }, [_c('button', {
    staticClass: "block",
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Spara")])])], 1) : _vm._e(), _vm._v(" "), (_vm.loggedIn) ? _c('div', [_c('p', [_vm._v("Du är redan inloggad. "), _c('router-link', {
    attrs: {
      "to": {
        name: 'my pages'
      }
    }
  }, [_vm._v("Klicka här")]), _vm._v(" om du vill gå till dina sidor.")], 1)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3abeccd0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/ResetPassword.vue
// module id = 946
// module chunks = 0